import { Tag } from 'antd'
import styled from 'styled-components'
import { accessibilityColors, white } from '@edulastic/colors'

export const BetaTag = styled(Tag)`
  left: ${({ left }) => left};
  top: ${({ top }) => top};
  background-color: ${({ backGroundColor }) => backGroundColor || white};
  border: 1.5px solid
    ${({ borderColor }) => borderColor || accessibilityColors.labels.blue.text};
  color: ${accessibilityColors.labels.blue.text};
`

export const BetaTag2 = styled.div`
  height: 23px;
  width: ${({ width }) => width || '44px'};
  background-color: ${white};
  color: ${accessibilityColors.labels.blue.text};
  margin-left: ${({ ml }) => ml || '3px'};
  margin-top: ${({ mt }) => mt || '-11px'};
  border: 1.5px solid
    ${({ borderColor }) => borderColor || accessibilityColors.labels.blue.text};
  border-radius: 2px;
  font: normal normal bold 10px/14px Open Sans;
  letter-spacing: 0.19px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
`
